import {
  Typography,
  Form,
  Input,
  DatePicker,
  Row,
  Col,
  Button,
  Select,
  InputNumber,
  TimePicker,
} from 'antd';

import { useAuth } from '../../hooks/useAuth';
import React, { useState, useEffect } from 'react';
import './BlockTrade.css';
import BlockTradeService from '../../services/BlockTradeService';
import SecurityService from '../../services/SecurityService';
import SecurityCompanyService from '../../services/SecurityCompanyService';

const { Title, Text } = Typography;

const BlockTrade = () => {
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [securities, setSecurities] = useState([]);
  const [securityCompanies, setSecurityCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabeledCounterPartyParticipants, setDisabeledCounterPartyParticipants] = useState(true);

  const onFinish = async formValues => {
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
      orderSideType: formValues.orderSideType,
      securityCode: formValues.securityCode,
      basePrice: formValues.basePrice,
      executedQuantity: formValues.executedQuantity,
      executedPrice: formValues.executedPrice,
      fixAcceptedId: formValues.fixAcceptedId,
      fixExecutedId: formValues.fixExecutedId,
      tradeWindow: formValues.tradeWindow.format('YYYYMMDD'),
      transferWindow: formValues.transferWindow.format('YYYYMMDD'),
      settlementWindow: formValues.settlementWindow.format('YYYYMMDD'),
      executionTime: formValues.executionTime.format('hh:mm:ss A'),
      tradingType: formValues.tradingType,
      counterPartyParticipants: formValues.counterPartyParticipants
        ? formValues.counterPartyParticipants
        : '_',
    };
    setLoading(true);
    const result = await BlockTradeService.createBlockTrade(payload);

    console.log(result);

    if (result.success) {
      showNotification('success', 'Successfully submitted');
      form.resetFields();
      setDisabeledCounterPartyParticipants(true);
    } else {
      showNotification('error', result.message);
    }
    setLoading(false);
  };

  const sortedSecurityCodes = securities.sort((a, b) => a.symbolCode.localeCompare(b.symbolCode));
  const securityCompanyName = securityCompanies.map(item => item.securityCompanyName).sort();

  // useEffect(() => {
  //   const getSecurities = async () => {
  //     let response = await SecurityService.getSecurities();
  //     console.log(response);
  //     if (response.success) setSecurities(response.securityDataList);
  //     else showNotification('error', response.message);
  //   };
  //   getSecurities();
  // }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);

      try {
        const securitiesPromise = SecurityService.getSecurities();
        const securityCompaniesPromise = SecurityCompanyService.getSecurityCompanyList();
        const [securitiesResponse, securityCompaniesResponse] = await Promise.all([
          securitiesPromise,
          securityCompaniesPromise,
        ]);
        if (securitiesResponse.success) {
          setSecurities(securitiesResponse.securityDataList);
        } else {
          showNotification('error', securitiesResponse.message);
        }
        if (securityCompaniesResponse.success) {
          setSecurityCompanies(securityCompaniesResponse.securityCompanyList);
        } else {
          showNotification('error', securityCompaniesResponse.message);
        }
      } catch (error) {
        showNotification('error', error.message || 'An error occurred while fetching data.');
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  const handleTradingTypeChange = value => {
    if (value === 'TRADING_WITH_OTHER_PARTICIPANTS') {
      setDisabeledCounterPartyParticipants(false);
    } else {
      setDisabeledCounterPartyParticipants(true);
      form.setFieldValue('counterPartyParticipants', undefined);
    }
  };

  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Block Trade
      </Title>
      <Form
        className="block-trade-form"
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 12,
        }}
        style={{
          padding: '2rem 0',
        }}
        // onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        <Row gutter={16}>
          <Col xs={24} sm={24} md={10}>
            <Form.Item
              label={'Trading Account No'}
              name={'tradingAccountNo'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={'Order Side Type'}
              name={'orderSideType'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                <Select.Option value="BUY">BUY</Select.Option>
                <Select.Option value="SELL">SELL</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Security Code"
              name={'securityCode'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                {sortedSecurityCodes.map((item, index) => (
                  <Select.Option key={index} value={item.securityCode}>
                    {item.symbolCode}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={'Base Price'}
              name={'basePrice'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                className="number-input"
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>
            <Form.Item
              label={'Executed Quantity'}
              name={'executedQuantity'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                className="number-input"
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>

            <Form.Item
              label={'Executed Price'}
              name={'executedPrice'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                className="number-input"
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>
            <Form.Item
              label={'Execution Time'}
              name={'executionTime'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <TimePicker use12Hours format="hh:mm:ss A" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={14}>
            <Form.Item
              label={'Fix Accepted ID'}
              name={'fixAcceptedId'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={'Fix Executed ID'}
              name={'fixExecutedId'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={'Trading Type'}
              name={'tradingType'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
              initialValue={'CROSS_TRADE'}
            >
              <Select
                defaultValue="CROSS_TRADE"
                style={{ width: '100%' }}
                onChange={value => handleTradingTypeChange(value)}
                options={[
                  { value: 'CROSS_TRADE', label: 'Cross Trade' },
                  {
                    value: 'TRADING_WITH_OTHER_PARTICIPANTS',
                    label: 'Trading with Other Participants',
                  },
                ]}
              />
            </Form.Item>
            <Form.Item label={'Counterparty Participants'} name={'counterPartyParticipants'}>
              <Select
                size="middle"
                disabled={disabeledCounterPartyParticipants}
                placeholder="Select Participants"
              >
                {securityCompanyName.map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={'Trade Window'}
              name={'tradeWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Transfer Window'}
              name={'transferWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Settlement Date'}
              name={'settlementWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default BlockTrade;
